import { render } from "./RcACE.vue?vue&type=template&id=597e8be0"
import script from "./RcACE.vue?vue&type=script&lang=js"
export * from "./RcACE.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__